import Vue from 'vue'
import {library} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

Vue.component('font-awesome-icon', FontAwesomeIcon)

import {faUser, faThumbsUp, faQuestionCircle} from '@fortawesome/free-regular-svg-icons'
import {faLanguage, faWifi, faSearch, faTrashAlt, faPlus, faLock, faUnlock, faBeer, faHouseUser, faShareAlt, faFileContract} from '@fortawesome/free-solid-svg-icons'

library.add(faLanguage, faWifi, faSearch, faTrashAlt, faPlus, faLock, faUnlock, faBeer, faHouseUser, faShareAlt, faFileContract)
library.add(faUser, faThumbsUp, faQuestionCircle)
